import { useQuery } from "react-query";
import { Teacher } from "../types";
import firebase from "firebase";

const useTeachers = () => {
  const { isLoading, error, data } = useQuery<Teacher[]>("teachers", () =>
    firebase
      .firestore()
      .collection("administrators")
      .where("isTeacher", "==", true)
      .get()
      .then((snapshot) => {
        const teachers: Teacher[] = [];
        snapshot.forEach((doc) => {
          const data = doc.data() as Teacher;
          teachers.push({
            ...data,
            teacherId: doc.id,
          });
        });
        return teachers;
      })
  );

  return { isLoading, error, data };
};

export default useTeachers;
